import { ChangeDetectorRef, Component } from '@angular/core';
import { CmsBannerComponent, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { UserInfoService } from '../../spartacus/services/user-info.service';

@Component({
  selector: 'app-initialuptake',
  standalone: false,
  templateUrl: './initialuptake.component.html',
  styleUrls: ['./initialuptake.component.scss']
})
export class InitialuptakeComponent {
  constructor( private userInfoService:UserInfoService,protected config: OccConfig,public bannerComponent: CmsComponentData<CmsBannerComponent>,private cdr: ChangeDetectorRef ){}
  initialdata: Observable<any> = this.bannerComponent.data$; 

  getImage(image: any): string {
    return this.config.backend?.occ?.baseUrl + image?.url;
  }
  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  screenvalue:number=999
  navigatetolanding(){
    this.userInfoService.setuptake(999);
    this.scrollToTop();
  }
  ngOnInit() {
   this.userInfoService.getuptake().subscribe((value:any)=>{
   this.screenvalue=value
   this.cdr.detectChanges()
   });
  }
}
